import React from "react";
import styles from "./Services.module.css";

const SERVICES = [
  {
    title: "General Cleaning",
    desc: "Routine cleaning for homes, offices and shops to keep everyday spaces fresh.",
    icon: "🧹",
  },
  {
    title: "Deep Cleaning",
    desc: "A thorough top-to-bottom clean for spaces that need extra attention.",
    icon: "✨",
  },
  {
    title: "Post-Renovation Cleaning",
    desc: "Dust, debris and leftover mess cleared so a renovated space is ready to use.",
    icon: "🧽",
  },
  {
    title: "Plumbing",
    desc: "Leak fixes, pipe work and fittings handled by experienced hands.",
    icon: "🔧",
  },
  {
    title: "Electrical Work",
    desc: "Wiring, fittings and repairs carried out safely and to code.",
    icon: "💡",
  },
  {
    title: "Painting",
    desc: "Interior and exterior painting with clean, even, lasting finishes.",
    icon: "🎨",
  },
  {
    title: "Kitchen & Bathroom Renovation",
    desc: "Full renovations that balance function, durability and good looks.",
    icon: "🛁",
  },
  {
    title: "Installation & Repair",
    desc: "Fixtures, fittings and appliances installed or repaired properly.",
    icon: "🛠️",
  },
  {
    title: "General Maintenance",
    desc: "Ongoing upkeep and small fixes so properties stay in good condition.",
    icon: "📋",
  },
];

export default function Services() {
  return (
    <section id="services" className={styles.section}>
      <div className="container">
        <div className={styles.heading}>
          <p className="jc-eyebrow">What We Do</p>
          <h2 className={styles.title}>Cleaning and renovation, under one roof</h2>
          <p className={styles.desc}>
            One reliable team for every job — from a quick clean-up to a full
            renovation — for homes, offices, shops and other properties.
          </p>
        </div>

        <div className="row g-4">
          {SERVICES.map((service) => (
            <div className="col-12 col-sm-6 col-lg-4" key={service.title}>
              <div className={styles.card}>
                <div className={styles.icon} aria-hidden="true">
                  {service.icon}
                </div>
                <h3 className={styles.cardTitle}>{service.title}</h3>
                <p className={styles.cardDesc}>{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
